import { i18nMark, Trans } from 'lingui-react';
import React from 'react';
import PropTypes from 'prop-types';
import { H3, Tabs } from 'base-components';
import { Row, Column } from 'styled-components-reactive-grid';

import Panel from 'blocks/Panel';
import Notes from './Notes';
import UnifiedHistory from './UnifiedHistory';
import StatusUpdates from './StatusUpdates';
import FieldUpdates from './FieldUpdates';
import CallHistory from './CallHistory';
import NotificationHistory from './NotificationHistory';

const tabsList = [
  i18nMark('Notes'),
  i18nMark('All'),
  i18nMark('Status Updates'),
  i18nMark('Field Updates'),
  i18nMark('Call History'),
  i18nMark('Notifications'),
];

function renderTabs() {
  return tabsList.map(name => (
    <Tabs.ListItem key={name}>
      <Tabs.ListItemButton aria-label={`tab-link-${name}`}>
        <Trans id={name} />
      </Tabs.ListItemButton>
    </Tabs.ListItem>
  ));
}

function CaseActivityPanel({ caseNumber }) {
  return (
    <Panel modifiers={['padScaleX_3']}>
      <Row>
        <Column modifiers={['padScaleY_2']}>
          <H3 modifiers={['fontWeightRegular']}>
            <Trans>Activity</Trans>
          </H3>
        </Column>
      </Row>
      <Row>
        <Tabs>
          <Tabs.Menu>
            <Tabs.List>{renderTabs()}</Tabs.List>
          </Tabs.Menu>
          <Tabs.Content>
            <Notes caseNumber={caseNumber} />
            <UnifiedHistory caseNumber={caseNumber} />
            <StatusUpdates caseNumber={caseNumber} />
            <FieldUpdates caseNumber={caseNumber} />
            <CallHistory caseNumber={caseNumber} />
            <NotificationHistory caseNumber={caseNumber} />
          </Tabs.Content>
        </Tabs>
      </Row>
    </Panel>
  );
}

CaseActivityPanel.propTypes = {
  caseNumber: PropTypes.string.isRequired,
};

export default CaseActivityPanel;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/index.js